import { createFileRoute } from '@tanstack/react-router'
import { CompanyJobDetail } from '@/features/company-job-detail'

export const Route = createFileRoute('/_authenticated/company-jobs/$jobId/')({
  component: CompanyJobDetail,
})
